export type ServiceType =
  | 'lead'
  | 'promotion'
  | 'menu'
  | 'feedback'
  | 'form'
  | 'iiko'
  | 'monitoring';
export const serviceMap: Record<ServiceType, string> = {
  lead: 'Лиды',
  promotion: 'Акции',
  menu: 'Меню',
  form: 'Формы',
  feedback: 'Дерево',
  iiko: 'Интеграция с iiko',
  monitoring: 'Мониторинг',
};
